import * as z from 'zod';
import { FcmTokenSchema } from '@padspin/firestore-fcm-tokens';
import { DateTimestampToDateAngularSchema } from '../firestore-interop';
import { TimestampDateFieldValueToTimestampFieldValueAngularSchema } from '../firestore-interop/timestamp';

export const FcmTokenAngularAppSchema = FcmTokenSchema.omit({
  created: true,
  updated: true,
}).extend({
  created: DateTimestampToDateAngularSchema.default(new Date()),
  updated: DateTimestampToDateAngularSchema.default(new Date()),
});

export type FcmTokenAngularAppModel = z.infer<typeof FcmTokenAngularAppSchema>;

export const FcmTokenAngularDbSchema = FcmTokenSchema.omit({
  created: true,
  updated: true,
}).extend({
  created: TimestampDateFieldValueToTimestampFieldValueAngularSchema.default(
    new Date(),
  ),
  updated: TimestampDateFieldValueToTimestampFieldValueAngularSchema.default(
    new Date(),
  ),
});

export type FcmTokenAngularDbModel = z.infer<typeof FcmTokenAngularDbSchema>;
